module.exports = `
... on SwiftypeSearchResult {
nameEn
heading
subheading
sortByText
noResults
}
`;
